import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vast%20ocean%20horizon%20at%20golden%20hour%20with%20dramatic%20warm%20light%20illuminating%20calm%20ocean%20waves%2C%20artistic%20impressionistic%20style%20with%20painterly%20texture%2C%20soft%20amber%20and%20terracotta%20sky%2C%20ethereal%20misty%20atmosphere%2C%20cinematic%20wide%20angle%2C%20highly%20detailed%20and%20evocative%20composition&width=1800&height=1000&seq=hero-home-2026&orientation=landscape"
          alt="海角千万资源原创 - 正版内容聚合平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-6 py-20">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-background-50 text-sm mb-8">
            <i className="ri-verified-badge-fill text-primary-400"></i>
            <span>千万正版素材库 · 全面版权保障</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            海角千万资源原创
            <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 text-primary-300 font-medium">
              正版内容聚合平台
            </span>
          </h1>
          <p className="text-background-50/85 text-base md:text-xl max-w-2xl mx-auto leading-relaxed mb-10">
            海量原创图文素材、原创视频资源聚合，为创作者与企业提供高质量、可信赖的
            <strong className="text-primary-300">正版原创资源</strong>，助力内容创作与品牌传播效率全面提升。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/image-text"
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap"
            >
              探索资源库 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/30 text-background-50 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap"
            >
              了解我们
            </Link>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { value: "1000万+", label: "原创资源总量" },
            { value: "5000+", label: "认证创作者" },
            { value: "200万+", label: "服务企业客户" },
            { value: "99.8%", label: "版权合规率" },
          ].map((stat, i) => (
            <div key={i} className="text-center px-3 py-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/15">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-300">{stat.value}</div>
              <div className="text-background-50/70 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center pt-1.5">
          <div className="w-1 h-2 bg-white/60 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}